// extracted by mini-css-extract-plugin
export default {"paginationControls":"PaginationControls_paginationControls__XBGuJ"};